import { Link } from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, Search} from '../../../partials'
import {useAppSelector} from "../../../../app/redux/hooks";

/* eslint-disable jsx-a11y/anchor-is-valid */
const AsideToolbar = () => {
  // const {currentUser} = useAuth()

  const {user} = useAppSelector(state => state.auth)
const {operator} = user
  return (
    <>
      {/*begin::User*/}
      <div className="aside-user d-flex align-items-sm-center justify-content-center py-5">
        {/*begin::Symbol*/}
        <div className="symbol symbol-50px">
          {operator.image? <img src={operator.image ?? ""} alt="" />:<div className={'d-flex align-items-center' +
              ' justify-content-center'} style={{width:50,height:50}}><KTIcon iconName={'user'} className={'fs-2' +
              ' text-gray'}/></div>}
        </div>
        {/*end::Symbol*/}

        {/*begin::Wrapper*/}
        <div className="aside-user-info flex-row-fluid flex-wrap ms-5">
          {/*begin::Section*/}
          <div className="d-flex">
            {/*begin::Info*/}
            <div className="flex-grow-1 me-2">
              {/*begin::Username*/}

              <span className="text-gray-600 fw-bold d-block fs-3 ">
                {operator.username}
              </span>
            </div>
          </div>
          {/*end::Section*/}
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::User*/}

      {/*end::Aside search*/}
    </>
  );
}

export {AsideToolbar}
